import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { UsersService } from '../../users/services/users.service';
import { UserNotificationComponent } from '../user-notification.component';

@Component({
  selector: 'app-user-notification-popup',
  templateUrl: './user-notification-popup.component.html',
  styleUrls: ['./user-notification-popup.component.scss'],
})
export class UserNotificationPopupComponent implements OnInit {
  public token;
  accountId: string;
  contactId: string;
  applicationForm: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    public auth: AuthenticationService,
    private loadingService: LoadingService,
    private userService: UsersService,
    public dialogRef: MatDialogRef<UserNotificationComponent>
  ) {}

  ngOnInit(): void {
    this.token = this.auth.getUserAccessToken();
    this.accountId = this.auth.getUserAccountId();
    this.contactId = this.auth.getPrimaryUserId();
    this.applicationForm = this.formBuilder.group({
      description: ['', Validators.required],
      subject: ['', Validators.required],
      contactId: [this.contactId, Validators.required],
      accountId: [this.accountId, Validators.required],
    });
  }
  onSubmit() {
    if (this.applicationForm.invalid) {
      this.auth.showSnackBarMsg('Please Fill All Options')
      return;
    }
    // console.log(this.applicationForm.value);
    this.loadingService.startLoading();
    this.userService
      .addNotification(this.token, this.applicationForm.value)
      .subscribe(
        (data) => {
          this.loadingService.stopLoading();
          this.dialogRef.close(true);
        },
        (error) => {
          console.log(error);
          this.loadingService.stopLoading();
          this.auth.showSnackBarMsg('Something went wrong!')
        }
      );
  }
}
